"use client";

import { useSyncExternalStore } from "react";

const subscribeNever = () => () => {};

/**
 * False during SSR and the hydration render, true afterwards. Lets motion
 * wrappers serve fully visible server HTML (for crawlers and no-JS readers)
 * and only engage entrance animations once the page is interactive.
 */
export function useHydrated(): boolean {
  return useSyncExternalStore(
    subscribeNever,
    () => true,
    () => false,
  );
}
